/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  GetUserRolesService,
  IGetUserRolesMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  GetAccessTokenService,
  IGetAccessTokenMethods,
} from './plugins';

export type SwitchRoleAgent = IGetUserRolesMethods &
  IStaticPageContentMethods &
  IGetAccessTokenMethods;

const getPlugins = () => {
  return [
    new GetUserRolesService(),
    new StaticPageContentService(),
    new GetAccessTokenService(),
  ];
};

export const getAgent = () => {
  return createAgent<SwitchRoleAgent>({
    plugins: getPlugins(),
  });
};
